export type QuestionnaireAnswers = Record<string, Record<string, unknown> | undefined>;

export type QuestionCondition =
  | { itemKey: string; field: string; equals: string | boolean }
  | { itemKey: string; field: string; oneOf: readonly (string | boolean)[] }
  | { any: readonly QuestionCondition[] };

export interface ConditionalQuestion {
  showIf?: QuestionCondition;
}

function matches(condition: QuestionCondition, answers: QuestionnaireAnswers): boolean {
  if ("any" in condition) return condition.any.some((entry) => matches(entry, answers));
  const value = answers[condition.itemKey]?.[condition.field];
  return "oneOf" in condition
    ? condition.oneOf.includes(value as string | boolean)
    : value === condition.equals;
}

export function isQuestionVisible(item: ConditionalQuestion, answers: QuestionnaireAnswers): boolean {
  return item.showIf ? matches(item.showIf, answers) : true;
}
